import { z } from 'zod';

/**
 * Task node - represents actionable items
 */
export const TaskPropsSchema = z.object({
  external_id: z.string().optional(),
  title: z.string().min(1, 'Title is required'),
  status: z.string().min(1, 'Status is required'),
  due_date: z.string().date().optional(),
  assigned_user_id: z.string().uuid().optional(),
});

export type TaskProps = z.infer<typeof TaskPropsSchema>;
